const SecurityTOTPActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  UPDATE_CHECKED_PHASES: 'update_checked_phases',
  UPDATE_TOTP_STEPS: 'update_totp_steps',
  UPDATE_TOTP_STEPS_STATUS: 'update_totp_steps_status',
  UPDATE_MAIN_SETTINGS: 'update_main_settings',
};

const SecurityTOTPReducer = (state, action) => {
  switch (action.type) {
    case SecurityTOTPActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case SecurityTOTPActionTypes.UPDATE_CHECKED_PHASES:
      return {
        ...state,
        checkedPhases: {
          ...state.checkedPhases,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case SecurityTOTPActionTypes.UPDATE_TOTP_STEPS:
      return {
        ...state,
        TOTPSteps: {
          ...state.TOTPSteps,
          [action.payload.stepName]: {
            ...state.TOTPSteps[`${action.payload.stepName}`],
            checked: action.payload.checked,
          },
        },
      };
    case SecurityTOTPActionTypes.UPDATE_TOTP_STEPS_STATUS:
      return {
        ...state,
        TOTPStepsOpened: action.payload,
      };
    case SecurityTOTPActionTypes.UPDATE_MAIN_SETTINGS:
      return { ...state, mainSettings: action.payload };

    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: SecurityTOTPActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const updateCheckedPhases = (dispatch) => (key, value) =>
  dispatch({ type: SecurityTOTPActionTypes.UPDATE_CHECKED_PHASES, payload: { key, value } });

const updateTOTPSteps = (dispatch) => (stepName, checked) =>
  dispatch({ type: SecurityTOTPActionTypes.UPDATE_TOTP_STEPS, payload: { stepName, checked } });

const updateMainSettings = (dispatch) => (settings) =>
  dispatch({ type: SecurityTOTPActionTypes.UPDATE_MAIN_SETTINGS, payload: settings });

const openTOTPStepsPopup = (dispatch) => () =>
  dispatch({ type: SecurityTOTPActionTypes.UPDATE_TOTP_STEPS_STATUS, payload: true });

const closeTOTPStepsPopup = (dispatch) => () =>
  dispatch({ type: SecurityTOTPActionTypes.UPDATE_TOTP_STEPS_STATUS, payload: false });

// eslint-disable-next-line import/prefer-default-export
export const securityTOTP = {
  SecurityTOTPReducer,
  actions: {
    openScreen,
    updateCheckedPhases,
    updateTOTPSteps,
    updateMainSettings,
    openTOTPStepsPopup,
    closeTOTPStepsPopup,
  },
};
